import React from 'react'

export const LikeIcon = ({
  fill = 'none',
  width = '18',
  height = '18',
  stroke = '#000000',
  strokeGradient = []
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill={fill}
    stroke={stroke === 'gradient' ? 'url(#gradient)' : stroke}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    width={width}
    height={height}
    cursor="pointer"
  >
    {
      strokeGradient.length
        ? (
          <defs>
            <linearGradient
              id="gradient"
              x1="60%"
              x2="40%"
              y1="40%"
              y2="60%"
              gradientUnits="userSpaceOnUse"
            >
              <stop
                offset="0%"
                stopColor={strokeGradient[0]}
              />
              <stop
                offset="100%"
                stopColor={strokeGradient[1]}
              />
            </linearGradient>
          </defs>
        ) : ''
    }

    <g id="SVGRepo_bgCarrier" strokeWidth="0" />
    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
    <g id="SVGRepo_iconCarrier">
      <path d="M14 9V5a3 3 0 00-3-3l-4 9v11h11.28a2 2 0 002-1.7l1.38-9a2 2 0 00-2-2.3zM7 22H4a2 2 0 01-2-2v-7a2 2 0 012-2h3" />
    </g>
  </svg>
)
